/**
 * @file
 * AOS (Animate On Scroll) initialization.
 */

(function (Drupal, drupalSettings) {
  'use strict';

  Drupal.behaviors.aosInit = {
    attach: function (context, settings) {
      // Initialize AOS only once
      if (typeof AOS !== 'undefined' && !AOS.initialized) {
        AOS.init({
          duration: 700,
          easing: 'ease-in-out',
          once: true,
          offset: -800,
          delay: 0,
          anchorPlacement: 'top-bottom'
        });
        AOS.initialized = true;
      }
    }
  };

})(Drupal, drupalSettings);
